<template>
	<div class="tipoatividade">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>

		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
			<li>
				<a href="/home"><i class="fa fa-home"></i></a>
				<a href="#">Tipo de Atividade</a>
			</li>
			</ol>
		</div>
		
		<div class="container-fluid mt-2">

			<ul class="nav nav-tabs" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" id="tipo-tab" data-toggle="tab" href="#tipo" role="tab" 
						aria-controls="tipo" aria-selected="true">
						Tipo de Atividade
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="subtipo-tab" data-toggle="tab" href="#subtipo" role="tab" 
					aria-controls="subtipo" aria-selected="false">
						Subtipo de Atividade
					</a>
				</li>
			</ul>
			<div class="tab-content" id="myTabContent">
				
				<!-- Tipo de Atividade -->
				<div class="container-fluid mt-2 tab-pane fade show active" id="tipo" role="tabpanel" aria-labelledby="tipo-tab">
					
					<div class="card">
						<div class="card-body">
							<div class="row p-2">
								<div class="col-1 text-right mt-1">
									Filtro: 
								</div>
								<div class="col">
									<input placeholder="Filtrar Tipo de Atividade" v-model="filtroTipo" 
										@keyup="filtrarTipo" />
								</div>
								<div class="col text-right">
									<button type="button" class="btn btn-primary"
										@click="abrirModalAdd('tipo')">
										<i class="fas fa-plus-circle mr-2"></i>	
										Tipo de Atividade
									</button>
								</div>
							</div>

							<div class="form-row">
								<el-table class="table-responsive table-action"
										empty-text="Nenhum tipo de atividade encontrado"
										header-row-class-name="thead-light"
										:data="tipos">

									<el-table-column label="Nome" prop="nome" sortable>
										<div slot-scope="{row}" class="table-actions">
											{{row.nome.substring(0, 35).trim()}}<span v-if="row.nome.length > 35">...</span>
										</div>
									</el-table-column>

									<el-table-column label="Descrição" prop="descricao" sortable>
										<div slot-scope="{row}" class="table-actions">
											{{row.descricao.substring(0, 80).trim()}}<span v-if="row.nome.length > 80">...</span>
										</div>
									</el-table-column>

									<el-table-column label="Ativo" prop="ativo" min-width="25px" align="center" class="text-center" sortable>
										<div slot-scope="{row}" class="table-actions">
											<span v-if="row.isAtivo"><i class="fas fa-check-circle text-success"></i></span>
											<span v-if="!row.isAtivo"><i class="far fa-circle text-danger"></i></span>
										</div>
									</el-table-column>

									<el-table-column min-width="25px" align="center">
										<div slot-scope="{row}" class="table-actions">
											<el-tooltip :content="`Alterar `+ row.nome" placement="top">
												<i class="fas fa-edit pr-2 pl-2 text-warning clickable"
													@click="abrirModalAlterar('tipo', row)" ></i>
											</el-tooltip>
											<el-tooltip :content="`Excluir `+ row.nome" placement="top">
												<i class="far fa-trash-alt pr-2 pl-2 text-danger clickable"
													@click="excluirTipo(row)" ></i>
											</el-tooltip>
										</div>
									</el-table-column>

								</el-table>
							</div>

						</div>
					</div>

				</div>
				<!-- Fim: Tipo de Atividade -->

				<!-- Subtipo de Atividade -->
				<div class="container-fluid mt-2 tab-pane fade show" id="subtipo" role="tabpanel" aria-labelledby="subtipo-tab">
					
					<div class="card">
						<div class="card-body">
							<div class="row p-2">
								<div class="col-1 text-right mt-1">
									Filtro: 
								</div>
								<div class="col">
									<input placeholder="Filtrar Subtipo de Atividade" v-model="filtroSubtipo" 
										@keyup="filtrarSubtipo" />
								</div>
								<div class="col text-right">
									<button type="button" class="btn btn-primary"
										@click="abrirModalAdd('subtipo')">
										<i class="fas fa-plus-circle mr-2"></i>	
										Subtipo de Atividade
									</button>
								</div>
							</div>

							<div class="form-row">
								<el-table class="table-responsive table-action"
										empty-text="Nenhum tipo de atividade encontrado"
										header-row-class-name="thead-light"
										:data="subtipos">

									<el-table-column label="Nome" prop="nome" sortable>
										<div slot-scope="{row}" class="table-actions">
											{{row.nome.substring(0, 30).trim()}}<span v-if="row.nome.length > 30">...</span>
										</div>
									</el-table-column>

									<el-table-column label="Descrição" prop="descricao" sortable>
										<div slot-scope="{row}" class="table-actions">
											{{row.descricao.substring(0, 45).trim()}}<span v-if="row.nome.length > 45">...</span>
										</div>
									</el-table-column>

									<el-table-column label="Tipo" prop="tipoatividade.nome" sortable>
										<div slot-scope="{row}" class="table-actions">
											{{row.tipoatividade.nome.substring(0, 30).trim()}}<span v-if="row.tipoatividade.nome.length > 30">...</span>
										</div>
									</el-table-column>

									<el-table-column label="Ativo" prop="ativo" min-width="35px" align="center" class="text-center" sortable>
										<div slot-scope="{row}" class="table-actions">
											<span v-if="row.isAtivo"><i class="fas fa-check-circle text-success"></i></span>
											<span v-if="!row.isAtivo"><i class="far fa-circle text-danger"></i></span>
										</div>
									</el-table-column>

									<el-table-column min-width="35px" align="center">
										<div slot-scope="{row}" class="table-actions">
											<el-tooltip :content="`Alterar `+ row.nome" placement="top">
												<i class="fas fa-edit pr-2 pl-2 text-warning clickable"
													@click="abrirModalAlterar('subtipo', row)" ></i>
											</el-tooltip>
											<el-tooltip :content="`Excluir `+ row.nome" placement="top">
												<i class="far fa-trash-alt pr-2 pl-2 text-danger clickable"
													@click="excluirSubtipo(row)" ></i>
											</el-tooltip>
										</div>
									</el-table-column>

								</el-table>
							</div>

						</div>
					</div>

				</div>
				<!-- Fim: subtipo de Atividade -->

			</div>		
		</div>	

		<modal :show.sync="modals.modalSubtipo">
			<form class="ml-3 mt-3 mr-3 mb-3">
				<h4 class="text-center">{{opcao.label}} Subtipo de Atividade</h4>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left"></i></span>
					</div>   
					<input type="text" class="form-control mb-2" v-model="novoTipo.nome" placeholder="Nome" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left"></i></span>
					</div>   
					<input type="text" class="form-control mb-2" v-model="novoTipo.descricao" placeholder="Descrição" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2" style="height: 40px;">
						<span class="input-group-text"><i class="fas fa-user-circle"></i></span>
					</div>   
					<select class="form-control" v-model="novoTipo.tipoatividade" size="1" style="height:40px;">
						<option value="null">Selecione o tipo da atividade</option>
						<option v-for="tipo in listaTipos" :key="tipo.id" :value="tipo">{{ tipo.nome }}</option>
					</select>   
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-toggle-off"></i></span>
					</div>   
					<div class="col-2 custom-switch ml-2 mt-1 campoForm">

						<input type="checkbox" v-model="novoTipo.isAtivo"
							class="custom-control-input"
							id="check3"/>
						<label class="custom-control-label" for="check3">Ativo</label>
					</div>
				</div>
				
				<br class="clear"/>
				<div class="col-md-12 text-center mt-3">
					<button type="button" class="btn btn-danger" @click="fecharModal">Desistir</button>
					<button type="button" class="btn btn-primary ml-4" @click="alterarTipo('subtipo')">
						{{opcao.name}}
					</button>
				</div>  
			</form> 
		</modal> 	

		<modal :show.sync="modals.modalTipo">
			<form class="ml-3 mt-3 mr-3 mb-3">
				<h4 class="text-center">{{opcao.label}} Tipo de Atividade</h4>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left"></i></span>
					</div>   
					<input type="text" class="form-control mb-2" v-model="novoTipo.nome" placeholder="Nome" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left"></i></span>
					</div>   
					<input type="text" class="form-control mb-2" v-model="novoTipo.descricao" placeholder="Descrição" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-toggle-off"></i></span>
					</div>   
					<div class="col-2 custom-switch ml-2 mt-1 campoForm">

						<input type="checkbox" v-model="novoTipo.isAtivo"
							class="custom-control-input" id="check1"/>
						<label class="custom-control-label" for="check1">Ativo</label>
					</div>
				</div>
				
				<br class="clear"/>
				<div class="col-md-12 text-center mt-3">
					<button type="button" class="btn btn-danger" @click="fecharModal">Desistir</button>
					<button type="button" class="btn btn-primary ml-4" @click="alterarTipo('tipo')">
						{{opcao.name}}
					</button>
				</div>  
			</form> 
		</modal> 
		
	</div>
</template>

<script>
import { Table, TableColumn, Tooltip } from 'element-ui'

export default {
	components: {
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
	},
	created(){
		this.carregarTipos();
		this.carregarSubtipos();
	},
	data() {
		return {
			tipos: [],
			tiposFiltro: [],
			subtipos: [],
			subtiposFiltro: [],
			filtroTipo: '',
			filtroSubtipo: '',
			listaTipos: [],
			novoTipo : {
				idstipoatividade: null,
				idsubtipoatividade: null,
				tipoatividade: null,
				nome: '',
				descricao: '',
				isAtivo: true
			},
			modals : {
				modalTipo : false,
				modalSubtipo : false,
			},
			opcao: {
				label: "Adicionar",
				name: "Incluir",
			},
			progress: true,
		};
	},
	methods: {
		filtrarTipo() {
			if (this.filtroTipo === "") {
				this.tipos = this.tiposFiltro;
			} else {
				this.tipos = this.tiposFiltro.filter((item) => {
					return (item.nome.toUpperCase().indexOf(this.filtroTipo.toUpperCase())>=0 || 
					item.descricao.toUpperCase().indexOf(this.filtroTipo.toUpperCase())>=0);
				})
			}
		},
		filtrarSubtipo() {
			if (this.filtroSubtipo === "") {
				this.subtipos = this.subtiposFiltro;
			} else {
				this.subtipos = this.subtiposFiltro.filter((item) => {
					return (item.nome.toUpperCase().indexOf(this.filtroSubtipo.toUpperCase())>=0 || 
					item.descricao.toUpperCase().indexOf(this.filtroSubtipo.toUpperCase())>=0);
				})
			}
		},
		carregarTipos() {
			this.progress = true;
			this.$clubApi.get('/tipoatividade').then(response => {
				this.tipos = response.data.object;
				this.tiposFiltro = response.data.object;
			})
			.catch(error => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		carregarSubtipos() {
			this.progress = true;
			this.$clubApi.get('/subtipoatividade').then(response => {
				this.subtipos = response.data.object;
				this.subtiposFiltro = response.data.object;
			})
			.catch(error => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		abrirModalAdd(opcao) {
			this.opcao.label = "Adicionar";
			this.opcao.name = "Incluir";
			if (opcao === 'subtipo') {
				this.progress = true;
				this.$clubApi.get('/tipoatividade/ativo').then(response => {
					this.listaTipos = response.data.object;
					this.modals.modalSubtipo = true;
				})
				.catch(error => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
			}
			this.modals.modalTipo = (opcao === 'tipo');
			this.novoTipo = {
				idtipoatividade: null,
				idsubtipoatividade: null,
				tipoatividade: null,
				nome: '',
				descricao: '',
				isAtivo: true
			}
		},
		abrirModalAlterar(e, tipo) {
			this.opcao.label = "Alterar";
			this.opcao.name = "Alterar";
			this.novoTipo = {
				idtipoatividade: tipo.idtipoatividade,
				idsubtipoatividade: tipo.idsubtipoatividade,
				tipoatividade: tipo.tipoatividade,
				nome: tipo.nome,
				descricao: tipo.descricao,
				isAtivo: tipo.isAtivo
			},
			this.modals.modalTipo = (e === 'tipo');
			if (e === 'subtipo') {
				this.progress = true;
				this.$clubApi.get('/tipoatividade/ativo').then(response => {
					this.listaTipos = response.data.object;
					this.modals.modalSubtipo = true;
				})
				.catch(error => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
			}
		},
		alterarTipo(tipo) {
			if (this.validacaoFormTipo(tipo)) {
				this.modals.modalTipo = false;
				this.modals.modalSubtipo = false;
				const options = {title: 'Confirmação', okLabel: 'Sim', cancelLabel: 'Não'}
				this.$dialogs.confirm('Deseja realmente '+ this.opcao.name.toLowerCase() +' "'+ this.novoTipo.nome +'"?', options)
				.then(res => {
					if(res.ok){
						this.progress = true;
						this.$clubApi.post('/'+ tipo +'atividade', this.novoTipo).then(() => {
							this.$toastr.success("Cadastro realizado com sucesso!");
							this.carregarTipos()
							this.carregarSubtipos()
						}) .catch((error) => {
							this.$toastr.error(error.response.data.msg);
						}).finally(() =>{
							this.progress = false;
						})
					}
				})
			} else {
				this.$toastr.error("Campos com preenchimento obrigatório!");
			}
		},
		fecharModal() {
			this.novoTipo = {
				idtipoatividade: null,
				idsubtipoatividade: null,
				tipoatividade: null,
				nome: '',
				descricao: '',
				isAtivo: true
			}
			this.modals.modalTipo = false;
			this.modals.modalSubtipo = false;
		},
		excluirTipo(tipo){
			const options = {title: 'Confirmação', okLabel: 'Apagar', cancelLabel: 'Não'}
			this.$dialogs.confirm('Deseja realmente apagar "'+ tipo.nome +'"?', options)
			.then(res => {
				if(res.ok){
					this.progress = true;
					this.$clubApi.delete('/tipoatividade/'+ tipo.idtipoatividade).then(() => {
						this.$toastr.success("Tipo de atividade apagado com sucesso!");
						this.carregarTipos();
					})
					.catch(error => {
						this.$toastr.error(error.response.data.msg);
					})
					.finally(() => {
						this.progress = false;
					});
				}
			});
		},
		excluirSubtipo(subtipo){
			const options = {title: 'Confirmação', okLabel: 'Apagar', cancelLabel: 'Não'}
			this.$dialogs.confirm('Deseja realmente apagar "'+ subtipo.nome +'"?', options)
			.then(res => {
				if(res.ok){
					this.progress = true;
					this.$clubApi.delete('/subtipoatividade/'+ subtipo.idsubtipoatividade).then(() => {
						this.$toastr.success("Subtipo de atividade apagado com sucesso!");
						this.carregarSubtipos();
					})
					.catch(error => {
						this.$toastr.error(error.response.data.msg);
					})
					.finally(() => {
						this.progress = false;
					});
				}
			});
		},
		validacaoFormTipo(tipo) {
			if (this.novoTipo.nome == '' || this.novoTipo.descricao == '') {
				return false;
			}
			if (tipo === "subtipo" && this.novoTipo.tipoatividade == null) {
				return false;
			}
			return true; 
		}
	}
};
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}
</style>